module.exports = __webpack_public_path__ + "img/enterprise_carclub_white.effe83dc.png";